var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgIconFlagFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.52344 2.5C5.93765 2.5 6.27344 2.83579 6.27344 3.25V4.25H19.0234C19.2779 4.25 19.5151 4.37906 19.6533 4.59277C19.7914 4.80649 19.8118 5.07569 19.7074 5.30777L17.7344 9.69223C17.6463 9.88796 17.6463 10.112 17.7344 10.3078L19.7074 14.6922C19.8118 14.9243 19.7914 15.1935 19.6533 15.4072C19.5151 15.6209 19.2779 15.75 19.0234 15.75H6.27344V21.75C6.27344 22.1642 5.93765 22.5 5.52344 22.5C5.10922 22.5 4.77344 22.1642 4.77344 21.75V3.25C4.77344 2.83579 5.10922 2.5 5.52344 2.5Z",
    fill: "#323544"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagFilled);
export default __webpack_public_path__ + "static/media/icon-flag-filled.b5b2f1102575ea64dd75d2eaa90497eb.svg";
export { ForwardRef as ReactComponent };